import { render, staticRenderFns } from "./AdvertisementInvoices.vue?vue&type=template&id=252975dc&scoped=true"
import script from "./AdvertisementInvoices.vue?vue&type=script&lang=js"
export * from "./AdvertisementInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252975dc",
  null
  
)

export default component.exports